// Copyright (c) 2018 Comsearch, Inc., All rights reserved

const getInitialValues = () => ({
  advancedSearch: '',
  'adv-architectureId': '',
  'adv-filterReferenceCode': '',
  'adv-modulationDescription': '',
  'adv-modulationSchemeDescription': '',
  'adv-modulationTypeId': '',
  'adv-powerType': '',
  'adv-radioTypeId': '',
  'adv-statusId': '',
  'adv-throughput': '',
  'adv-txPowerMax': '',
  bandwidth: '',
  companyName: '',
  frequency: '',
  modelNumber: '',
  radioCode: '',
  radioFamilyName: '',
  pagination: null,
})

export default getInitialValues
